import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SectionApp from './components/SectionApp';
import SectionAbout from './components/SectionAbout';
import SectionCarousel from './components/SectionCarousel';
import SectionCards from './components/SectionCards';
import SectionContact from './components/SectionContact';
import SectionComments from './components/SectionComments';
import SectionRanking from './components/SectionRanking';
import SectionIndex from './components/SectionIndex';
import SectionFaq from './components/SectionFaq';
import SectionMedia from './components/SectionMedia';
import SectionFeatures from './components/SectionFeatures';
import SectionTopics from './components/SectionTopics';
import SectionUpdates from './components/SectionUpdates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <SectionApp />
        <SectionAbout />
        <SectionCarousel />
        <SectionCards />
        <SectionContact />
        <SectionComments />
        <SectionRanking />
        <SectionIndex />
        <SectionFaq />
        <SectionMedia />
        <SectionFeatures />
        <SectionTopics />
        <SectionUpdates />
      </main>
      <Footer />
    </div>
  );
}